"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ColorField_1 = __importDefault(require("../ColorField/ColorField"));
var OffsetField_1 = __importDefault(require("../OffsetField/OffsetField"));
var antd_1 = require("antd");
var OpacityField_1 = __importDefault(require("../OpacityField/OpacityField"));
var LocaleWrapper_1 = require("../../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../../locale/en_US"));
var _get = require('lodash/get');
/**
 * ColorMapEntry Field
 */
var ColorMapEntryField = /** @class */ (function (_super) {
    __extends(ColorMapEntryField, _super);
    function ColorMapEntryField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.updateColorMapEntry = function (prop, value) {
            var _a = _this.props, colorMapEntry = _a.colorMapEntry, onChange = _a.onChange;
            var updated = __assign({}, colorMapEntry);
            updated[prop] = value;
            if (onChange) {
                onChange(updated);
            }
        };
        _this.onColorChange = function (color) {
            _this.updateColorMapEntry('color', color);
        };
        _this.onQuantityChange = function (quantity) {
            _this.updateColorMapEntry('quantity', quantity);
        };
        _this.onLabelChange = function (label) {
            _this.updateColorMapEntry('label', label);
        };
        _this.onOpacityChange = function (opacity) {
            _this.updateColorMapEntry('opacity', opacity);
        };
        return _this;
    }
    ColorMapEntryField.prototype.render = function () {
        var _this = this;
        var _a = this.props, colorMapEntry = _a.colorMapEntry, labelPlaceholder = _a.labelPlaceholder, locale = _a.locale;
        var formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        return (React.createElement("div", null,
            React.createElement(antd_1.Form.Item, __assign({ label: locale.colorLabel }, formItemLayout),
                React.createElement(ColorField_1.default, { color: _get(colorMapEntry, 'color'), onChange: this.onColorChange })),
            React.createElement(antd_1.Form.Item, __assign({ label: locale.quantityLabel }, formItemLayout),
                React.createElement(OffsetField_1.default, { offset: _get(colorMapEntry, 'quantity'), onChange: this.onQuantityChange })),
            React.createElement(antd_1.Form.Item, __assign({ label: locale.labelLabel }, formItemLayout),
                React.createElement(antd_1.Input, { className: "editor-field colormapentry-label-field", defaultValue: _get(colorMapEntry, 'label'), value: _get(colorMapEntry, 'label'), placeholder: labelPlaceholder, onChange: function (evt) {
                        _this.onLabelChange(evt.target.value);
                    } })),
            React.createElement(antd_1.Form.Item, __assign({ label: locale.opacityLabel }, formItemLayout),
                React.createElement(OpacityField_1.default, { opacity: _get(colorMapEntry, 'opacity'), onChange: this.onOpacityChange }))));
    };
    ColorMapEntryField.componentName = 'ColorMapEntryField';
    ColorMapEntryField.defaultProps = {
        labelPlaceholder: 'Color Map Label',
        locale: en_US_1.default.GsColorMapEntryField
    };
    return ColorMapEntryField;
}(React.PureComponent));
exports.ColorMapEntryField = ColorMapEntryField;
exports.default = LocaleWrapper_1.localize(ColorMapEntryField, ColorMapEntryField.componentName);
//# sourceMappingURL=ColorMapEntryField.js.map